<nav
          class="hidden lg:flex items-center space-x-6 text-sm font-medium text-black dark:text-white lg:mx-24 pl-28 ml-10 cursor-pointer animate__animated animate__rotateInDownLeft animate__delay-1s"
        >
          <!-- HOME -->
          <div class="hover:bg-primary rounded-full p-2 transition-all group relative" matTooltip="Inicio">
            <a *ngIf="isAuthenticated" (click)="gotoHome()" class="flex items-center hover:text-white focus:outline-none" aria-label="Ir a inicio">
              <icon-home class="text-black dark:text-white transition-colors" />
            </a>
            <span
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary text-white text-xs rounded py-1 px-2 absolute top-full left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap pointer-events-none z-50"
            >
              {{ 'MENU-NAV.HOME' | translate}}
            </span>
          </div>

          <!-- DOWNLOAD -->
          <div class="hover:bg-primary rounded-full p-2 transition-all group relative" matTooltip="Descargar App">
            <a (click)="appDownload()" class="flex items-center hover:text-white focus:outline-none" aria-label="Descargar App">
              <icon-download class="text-black dark:text-white transition-colors" />
            </a>
            <span
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary text-white text-xs rounded py-1 px-2 absolute top-full left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap pointer-events-none z-50"
            >
              {{ 'MENU-NAV.DOWNLOAD-APP' | translate}}
            </span>
          </div>

          <!-- VEHÍCULO -->
          <div class="hover:bg-primary rounded-full p-2 transition-all group relative" *ngIf="isAuthenticated" matTooltip="Mi vehículo">
            <a (click)="gotoVehicle()" class="flex items-center hover:text-white focus:outline-none" aria-label="Mi vehículo">
              <icon-car class="text-black dark:text-white transition-colors" />
            </a>
            <span
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary text-white text-xs rounded py-1 px-2 absolute top-full left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap pointer-events-none z-50"
            >
              {{ 'MENU-NAV.VEHICLE' | translate}}
            </span>
          </div>

          <!-- CALENDARIO -->
          <div class="hover:bg-primary rounded-full p-2 transition-all group relative" *ngIf="isAuthenticated" matTooltip="Calendario">
            <a (click)="goToCalendar()" class="flex items-center hover:text-white focus:outline-none" aria-label="Calendario">
              <icon-notes-edit class="text-black dark:text-white transition-colors" />
            </a>
            <span
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary text-white text-xs rounded py-1 px-2 absolute top-full left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap pointer-events-none z-50"
            >
              {{ 'MENU-NAV.CALENDAR' | translate}}
            </span>
          </div>

          <!-- IDIOMA -->
          <div class="hover:bg-primary rounded-full p-2 transition-all group relative" *ngIf="isAuthenticated" matTooltip="Comunidad">
            <a (click)="gotoCommunity()" class="flex items-center hover:text-white focus:outline-none" aria-label="Comunidad">
              <icon-globe class="text-black dark:text-white transition-colors" />
            </a>
            <span
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary text-white text-xs rounded py-1 px-2 absolute top-full left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap pointer-events-none z-50"
            >
              {{ 'MENU-NAV.COMMUNITY' | translate}}
            </span>
          </div>

          <!-- WHATSAPP -->
          <div class="hover:bg-primary rounded-full p-2 transition-all group relative" matTooltip="WhatsApp">
            <a (click)="gotoWhatsapp()" class="flex items-center hover:text-white focus:outline-none" aria-label="WhatsApp">
              <icon-whatsapp class="text-black dark:text-white transition-colors" />
            </a>
            <span
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary text-white text-xs rounded py-1 px-2 absolute top-full left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap pointer-events-none z-50"
            >
              {{ 'MENU-NAV.WHATSAPP' | translate}}
            </span>
          </div>

          <!-- NOTIFICACIONES -->
          <div class="hover:bg-primary rounded-full p-2 transition-all group relative" *ngIf="isAuthenticated" matTooltip="Notificaciones">
            <a (click)="gotoNotifications()" class="flex items-center hover:text-white focus:outline-none" aria-label="Notificaciones">
              <icon-bell-bing class="text-black dark:text-white transition-colors" />
            </a>
            <span
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary text-white text-xs rounded py-1 px-2 absolute top-full left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap pointer-events-none z-50"
            >
              {{ 'MENU-NAV.NOTIFICATIONS' | translate}}
            </span>
          </div>
        </nav>
